import { Box, Button, IconButton, Typography } from "@mui/material"
import { useStyles } from "./styles"
import { ItemNotifyProps } from "./types"
import { icons } from "../../../../../utils/icons"
import { useTranslation } from "react-i18next"

const NotificationBell = (props: ItemNotifyProps) => {
  const styles = useStyles({ type: props.type })
  const { t } = useTranslation()

  const openReportUrl = () => {
    window.open(props.reportUrl ?? '')
  }

  return (
    <Box sx={styles.container}>
      <Box sx={styles.statusRounded} />

      <Box sx={styles.containerActions}>
        <Typography sx={styles.date}>{props.date}</Typography>

        <IconButton onClick={() => { if (props?.remove) { props?.remove() } }} sx={styles.close}>{icons('simple-close')}</IconButton>
      </Box>

      <Typography sx={styles.title}>{props.title}</Typography>

      <Typography sx={styles.description}>{props.description}</Typography>

      {props.reportUrl &&
        <Button onClick={openReportUrl} sx={styles.button}>{t('general.seeReport')}</Button>
      }
    </Box>
  )
}

export { NotificationBell }
